









































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Getter,Action } from "vuex-class";
import store from "@/store";
import getUrlParam from "@/common/utils/getUrlParam";

@Component
export default class UserAgreementContentModal extends Vue {
  @Prop({ required: true }) showUserAgreementContent!: boolean;
  
  @Getter("openUser") openUser!: boolean;
  @Getter('channel') channel: any;
  @Action("changeShowFooter") changeShowFooter!: Function;

  isCopy: boolean = getUrlParam('state') == 'copy';
  broadcastId: string = getUrlParam('broadcastId') as string;

  handleViewUserAgreement(isOpen: boolean) {
    this.$emit("show");
  }
}
